import { appContent } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-900 scroll-mt-[72px]">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-white">
              移动追剧
            </h2>
            <p className="text-sm md:text-base text-foreground-300 mt-3 mb-8 leading-relaxed max-w-lg mx-auto lg:mx-0">
              {appContent.subtitle}
            </p>

            <div className="flex flex-col gap-3 mb-8">
              {appContent.features.map((f, idx) => (
                <div key={idx} className="flex items-center gap-3 justify-center lg:justify-start">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-500/20 flex-shrink-0">
                    <i className="ri-check-line text-primary-400 text-sm"></i>
                  </div>
                  <span className="text-sm text-foreground-200">{f}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-lg transition-all hover:scale-[1.02] whitespace-nowrap"
                onClick={(e) => e.preventDefault()}
              >
                <i className="ri-smartphone-line text-lg"></i>
                手机访问体验
              </a>
              <a
                href="#"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3 bg-white/10 hover:bg-white/15 text-white font-semibold text-sm rounded-lg border border-white/20 transition-all hover:scale-[1.02] whitespace-nowrap"
                onClick={(e) => e.preventDefault()}
              >
                <i className="ri-command-line text-lg"></i>
                添加桌面快捷方式
              </a>
            </div>
          </div>

          <div className="flex-shrink-0 w-56 md:w-64 lg:w-72">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl ring-2 ring-white/10">
              <img
                src={appContent.image}
                alt="8848影院移动端追剧体验"
                className="w-full h-auto"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}